// Frontend-only mirror of the admin half of
// api/src/access-control/dto/access-credential.dto.ts.
// Not synced via dto:sync — the backend DTO imports @nestjs/swagger decorators
// and entity-file enums, both of which dto-syncer.js treats as backend-only.

import { AccessControlProviderType } from './access-control-config.dto';

export enum AccessBookingType {
  GAME = 'game',
  COURT_BOOKING = 'court_booking',
  COACHING = 'coaching',
  EVENT = 'event',
}

export enum AccessCredentialType {
  PIN = 'pin',
  QR = 'qr',
  NFC = 'nfc',
  APP = 'app',
}

export enum AccessCredentialStatus {
  ACTIVE = 'active',
  USED = 'used',
  REVOKED = 'revoked',
  EXPIRED = 'expired',
}

/**
 * One credential issued against a booking. Spans all participants and all
 * reissues, so several rows can share a `userId` — a revoked predecessor plus
 * the ACTIVE code that replaced it after a time/court change.
 */
export type AdminAccessCredentialDto = {
  id: string;
  bookingType: AccessBookingType;
  bookingId: string;
  credentialType: AccessCredentialType;
  /**
   * Empty once the backend's retention sweep has blanked it
   * (`scrubExpiredCredentialSecrets`) — render as "no longer available", never
   * as a code.
   */
  credentialValue: string;
  provider: AccessControlProviderType;
  status: AccessCredentialStatus;
  doorIds: string[];
  courtIds: string[];
  validFrom: string;
  validUntil: string;
  createdAt: string;
  userId: string;
  userName: string;
};

export type GetBookingAccessCredentialsOutputDto = {
  credentials: AdminAccessCredentialDto[];
};
